import {ArenaGameFiltersCategoryBase} from "./arena-game-filters-category-base";
import {computed} from "mobx";
import {DynamicArenaGameFilter} from "../filters/dynamic-arena-game-filter";
import {NullableNumber} from "../../../../../common/types/nullable-types";
import {IArenaGameFiltersCategory} from "./arena-game-filters-category.interface";
import {IFilterCategoryDefinition} from "../../filters-categories-definitions/filter-category-definition.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {IGameFilterDefinition} from "../../filters-definitions/game-filter-definition.interface";

type AvailableFilterEvaluator = (filter: DynamicArenaGameFilter) => boolean;

export class DynamicArenaGameFiltersCategory extends ArenaGameFiltersCategoryBase {
    constructor(categoryDefinition: IFilterCategoryDefinition,
                services: IServiceFactoryExtended,
                private readonly _availableFilterEvaluator?: AvailableFilterEvaluator) {
        super(categoryDefinition, services);
    }

    protected _createArenaGameFilter(filterDefinition: IGameFilterDefinition): DynamicArenaGameFilter {
        return new DynamicArenaGameFilter(filterDefinition, this.services);
    }

    /**
     * Restrict available filters to only those that have applicable games in the current arena
     */
    @computed
    get availableFilters(): DynamicArenaGameFilter[] {
        return this._getAvailableFilters();
    }

    protected _getAvailableFilters(): DynamicArenaGameFilter[]{
        const availableFilterEvaluator: AvailableFilterEvaluator = this._availableFilterEvaluator ?? ((filter: DynamicArenaGameFilter) => filter.gamesCount > 0);
        return this.categoryDefinition.availableFilters
            .map(f =>  this._createArenaGameFilter(f))
            .filter(availableFilterEvaluator);
    }

    @computed
    get gamesCount(): NullableNumber {
        const uniqueGameTypes = new Set();
        this.availableFilters.forEach(f => {
            f.games.forEach(game => uniqueGameTypes.add(game.gameType))
        });
        return uniqueGameTypes.size;
    }

    protected _createSubcategory(subcategory: IFilterCategoryDefinition): IArenaGameFiltersCategory {
        return new DynamicArenaGameFiltersCategory(subcategory,
                                                  this.services,
                                () => true); // for sub categories we always include all filters in the availableFilters
    }



}